// @ts-check

/**
 * @file Renders the system-test fixture bootstrap route.
 */
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import {Text, View} from "react-native-propforge"
import ScreenTitle from "../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @type {Record<string, object>} */
const styles = {}

/** @typedef {{[key: string]: unknown}} SystemTestFixtureBootstrapRouteProps */

/** @typedef {Record<string, never>} SystemTestFixtureBootstrapRouteState */

/**
 * Blank Expo route used only to bootstrap backend fixture helpers in system tests.
 * @augments {ShapeComponent<SystemTestFixtureBootstrapRouteProps, SystemTestFixtureBootstrapRouteState>}
 */
class SystemTestFixtureBootstrapRoute extends ShapeComponent {
  /**
   * Renders the fixture bootstrap marker.
   * @returns {ReactNode} Fixture bootstrap content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{"Fixture bootstrap"}</ScreenTitle>
        <View
          style={styles.screen ||= {
            alignItems: "center",
            backgroundColor: "#ffffff",
            flex: 1,
            justifyContent: "center"
          }}
          testID="systemTestFixtureBootstrapScreen"
        >
          <Text
            style={styles.text ||= {
              color: "#111827",
              fontSize: 14
            }}
            testID="systemTestFixtureBootstrapScreen/text"
          >
            System test fixture bootstrap
          </Text>
        </View>
      </>
    )
  }
}

/** @type {NamedExoticComponent<SystemTestFixtureBootstrapRouteProps>} */
const SystemTestFixtureBootstrapRouteComponent = memo(shapeComponent(SystemTestFixtureBootstrapRoute))

export default SystemTestFixtureBootstrapRouteComponent
